let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7JX0n")).then(() => parcelRequire('4AGyV'));